import React from 'react';
import RouterProvider from 'routes/router-provider';
import 'react-quill/dist/quill.snow.css';

export default function App() {
  return <RouterProvider />;
}
